import { useBoundStore } from '@/store/store';

export function useUser() {
  const user = useBoundStore(state => state.user);
  const jwt = useBoundStore(state => state.jwt);
  const currentOrganizationId = useBoundStore(
    state => state.currentOrganizationId,
  );
  const logout = useBoundStore(state => state.logout);
  const setUser = useBoundStore(state => state.setUser);
  const setJwt = useBoundStore(state => state.setJwt);
  const activeSubscription = useBoundStore(state => state.activeSubscription);
  const setActiveSubscription = useBoundStore(
    state => state.setActiveSubscription,
  );
  const clearActiveSubscription = useBoundStore(
    state => state.clearActiveSubscription,
  );
  const hasFeature = useBoundStore(state => state.hasFeature);
  const setCurrentOrganizationId = useBoundStore(
    state => state.setCurrentOrganizationId,
  );

  return {
    user,
    jwt,
    currentOrganizationId,
    logout,
    setUser,
    setJwt,
    activeSubscription,
    setActiveSubscription,
    clearActiveSubscription,
    hasFeature,
    setCurrentOrganizationId,
  };
}
